
angular.module('gallery').directive('trackable', ['$window', function ($window) {
	return {
		restrict: 'A',
		scope: {},
		controller: 'trackCtrl',
		link: function(scope, elem, attr, trackCtrl) {
			var attrNames = Object.keys(attr);
			var meta = {};

			attrNames.forEach(function (value) {
				if (value.indexOf('meta') > -1) {
					meta[value.replace('meta', '').toLowerCase()] = attr[value];
				}
			});
			trackCtrl.setMeta(meta);

			angular.element($window).bind("scroll", function() {
				trackCtrl.debounceCheckVisibility();
			});
		}
	};
}]);





// WEBPACK FOOTER //
// ./assets/components/galleryPage/scripts/shared/trackableDirective.js